<template>
    <div class="survey_form">
        <div class="survey_progress">
            <div class="percent" :style="`left:${(result.currentPage + 1) / props.data.length * 100}%`">
                <span>{{ floatFormat((result.currentPage + 1) / props.data.length * 100) }}%</span>
            </div>
            <div class="count">
                <span><b>{{ result.currentPage + 1 }}</b>/ {{ props.data.length }}</span>
            </div>
            <div class="bar">
                <span v-for="item in props.data.length" :class="result.currentPage + 1 >= item ? 'full' : ''"></span>
            </div>
        </div>
        <div class="survey_content" v-if="result.currentPage < props.data.length" style="display: block;">
            <p class="survey_tit"><b>{{ result.currentPage + 1 }}.</b> {{ currentQuestion.title }}</p>
            <template v-if="currentQuestion.type === 1">
                <textarea @change="selectAnswer(currentQuestion.idx, 0, result.answer)" v-model="result.answer"
                    class="survey_text" placeholder="내 답변"></textarea>
            </template>
            <template v-if="currentQuestion.type === 2">
                <div class="check_list" style="display: block;">
                    <label class="radio" v-for="(option, optIndex) in currentQuestion.choiceList" :key="optIndex">
                        <input type="radio" :name="'question' + currentQuestion.idx" :value="option.idx"
                            @change="selectAnswer(currentQuestion.idx, option.idx)" v-model="result.selectRadio" />
                        <b></b>
                        <span>{{ option.title }}</span>
                    </label>
                </div>
            </template>
            <template v-if="currentQuestion.type === 3">
                <div class="check_list">
                    <label class="checkbox" v-for="(option, optIndex) in currentQuestion.choiceList" :key="optIndex">
                        <input type="checkbox" :name="'question' + currentQuestion.idx" :value="option.idx"
                            v-model="result.selectCheckBox"
                            @change="selectAnswerCheckBox(currentQuestion.idx, option.idx)" />
                        <b></b>
                        <span>{{ option.title }}</span>
                    </label>
                </div>
            </template>
            <template v-if="currentQuestion.type === 4">
                <div class="survey_check_box">
                    <div class="check_circle">
                        <label class="checkbox" v-for="(option, optIndex) in currentQuestion.choiceList"
                            :key="optIndex">
                            <input type="radio" :name="'question' + currentQuestion.idx" :value="option.idx"
                                @change="selectAnswer(currentQuestion.idx, option.idx)" v-model="result.selectRadio" />
                            <span>{{ optIndex }}</span>
                        </label>
                    </div>
                </div>
                <div class="survey_check_txt">
                    <span>스트레스 전혀 없음</span>
                    <span>극심한 스트레스</span>
                </div>
            </template>
            <div class="survey_btns" style="gap: 10px;">
                <button type="button" class="btn btn_blue" v-if="result.currentPage !== 0" @click="prevQuestion">
                    이전
                </button>
                <button type="button" class="btn btn_blue" v-if="result.currentPage !== props.data.length - 1"
                    @click="nextQuestion">
                    다음
                </button>
                <button type="button" class="btn btn_blue" v-if="result.currentPage === props.data.length - 1"
                    @click="checkSurvey()">제출</button>
            </div>
        </div>
    </div>
    <surveyModal :show="state.isModalOpen" :yes="modal.confirm" :no="modal.cancel" :content="modal.content"
        @close="modalClose"></surveyModal>
</template>
<script lang="ts" config>
import { computed, reactive, floatFormat, ModalComponent } from '@/BaseComponent';

interface answer {
    answer: string,
    choice: number,
    sqIdx: number,
    svIdx: number;
}

export default {
    props: {
        data: {
            required: true,
        },
        surveyIdx: {
            required: true,
        },
    },
    emits: ["submit"],
    components: {
        surveyModal: ModalComponent
    },
    setup(props: any, { emit }: any) {
        const state = reactive({
            isModalOpen: false as boolean
        });
        const modal = reactive({
            confirm: "" as string,
            cancel: "" as string,
            content: "" as string,
            activeCode: 0 as number,
            activeItem: null as any
        });
        const result = reactive({
            currentPage: 0 as number,
            answer: "" as string,
            selectRadio: null as number | null,
            selectCheckBox: [] as any,
            answerList: [] as Array<answer>
        });
        const currentQuestion = computed(() => props.data[result.currentPage]);

        const selectAnswerCheckBox = (sqIdx: number, choice: number = 0, answer: string = "") => {
            const existingResult = result.answerList.find(result => result.sqIdx === sqIdx && result.choice === choice);
            if (existingResult) {
                for (let i = 0; i < result.answerList.length; i++) {
                    if (result.selectCheckBox[i] === choice) {
                        result.selectCheckBox.splice(i, 1);
                    }
                    if (result.answerList[i] === existingResult) {
                        result.answerList.splice(i, 1);
                    }
                }
            } else {
                result.selectCheckBox.push(choice);
                result.answerList.push({
                    answer: answer,
                    choice: choice,
                    sqIdx: sqIdx,
                    svIdx: props.surveyIdx,
                });
            }
        };

        const selectAnswer = (sqIdx: number, choice: number = 0, answer: string = "") => {
            const existingResult = result.answerList.find(result => result.sqIdx === sqIdx);
            if (existingResult) {
                existingResult.choice = choice;
                existingResult.answer = answer;
            } else {
                result.answerList.push({
                    answer: answer,
                    choice: choice,
                    sqIdx: sqIdx,
                    svIdx: props.surveyIdx,
                });
            }
            result.selectRadio = choice;
        };

        const prevQuestion = () => {
            if (result.currentPage > 0) {
                result.currentPage--;
                const prevAnswer = result.answerList.find(result => result.sqIdx === currentQuestion.value.idx);
                result.selectRadio = prevAnswer ? prevAnswer.choice : null;
            }
        };

        const nextQuestion = () => {
            if (result.currentPage < props.data.length - 1) {
                result.currentPage++;
                const nextAnswer = result.answerList.find(result => result.sqIdx === currentQuestion.value.idx);
                result.selectRadio = nextAnswer ? nextAnswer.choice : null;
            }
        };

        const checkSurvey = () => {
            for (let i = 0; i < props.data.length; i++) {
                const question = props.data[i];
                const answer = result.answerList.find(result => result.sqIdx === question.idx);
                if (!answer) {
                    modal.activeItem = i;
                    break;
                }
            }
            if (modal.activeItem !== null) {
                state.isModalOpen = true;
                modal.content = `모든 질문에 답변해 주세요. 질문 ${modal.activeItem + 1}이(가) 비어 있습니다.`;
                modal.confirm = "확인";
                modal.cancel = "";
                modal.activeCode = 1;
            } else {
                state.isModalOpen = true;
                modal.content = `설문을 제출하시겠습니까?`;
                modal.confirm = "확인";
                modal.cancel = "취소";
                modal.activeCode = 2;
            }
        };

        const modalClose = (actionType: boolean) => {
            if (actionType) {
                switch (modal.activeCode) {
                    case 1:
                        result.currentPage = modal.activeItem;
                        break;
                    case 2:
                        emit("submit", result.answerList);
                        break;
                    default:
                        break;
                }
            } else if (!actionType) {
                switch (modal.activeCode) {
                    case 1:
                        break;
                    case 2:

                        break;
                    default:
                        break;
                }
            }
            state.isModalOpen = false;
            modal.activeItem = null;
        };
        return {
            props,
            state,
            result,
            modal,
            currentQuestion,
            nextQuestion,
            prevQuestion,
            selectAnswer,
            selectAnswerCheckBox,
            checkSurvey,
            floatFormat,
            modalClose,
        };
    }
};
</script>